// extracted by mini-css-extract-plugin
export var modalFooter = "_t2-0";